export default __webpack_public_path__ + "static/media/3435.18ca0781.png";